// Angular
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {
    provideHttpClient,
    withInterceptorsFromDi,
} from '@angular/common/http';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

// Material Design
import { MaterialDesignModule } from './Shared/Modules/MaterialDesign/material-design.module';

// Módulo de routing
import { AppRoutingModule } from './app-routing.module';
// Componentes
import { AppComponent } from './app.component';
import { LoginComponent } from './Shared/Pages/login/login.component';
import { NotFoundComponent } from './Shared/Pages/not-found/not-found.component';
import { RequestRestorePasswordComponent } from './Shared/Pages/request-restore-password/request-restore-password.component';
import { ChangePasswordComponent } from './Shared/Pages/change-password/change-password.component';
import { RestorePasswordComponent } from './Shared/Pages/restore-password/restore-password.component';
import { NgxUiLoaderModule } from 'ngx-ui-loader';
import { LoadingRestorePasswordComponent } from './Shared/Pages/loading-restore-password/loading-restore-password.component';

//Captcha
import { RecaptchaModule } from 'ng-recaptcha';
import { DialogNuevoAspiranteComponent } from './Shared/Pages/dialog-nuevo-aspirante/dialog-nuevo-aspirante.component';
import { MaintenanceComponent } from './Shared/Pages/maintenance/maintenance.component';
import { PeriodoPipe } from './Shared/Pipes/periodo.pipe';
import { EvaluacionPipe } from './Shared/Pipes/evaluacion.pipe';
import { GeneroPipe } from './Shared/Pipes/genero.pipe';
import { NivelAcademicoPipe } from './Shared/Pipes/nivel-academico.pipe';
import { NivelDesempenoPipe } from './Shared/Pipes/nivel-desempeno.pipe';
import { NgChartsModule } from 'ng2-charts';
import { LoadingComponent } from './Shared/Pages/loading/loading.component';
import { RECAPTCHA_V3_SITE_KEY, RecaptchaV3Module } from 'ng-recaptcha';
import { environment } from 'src/environments/environment';
import { LoadingValidateCorreoComponent } from './Shared/Pages/loading-validate-correo/loading-validate-correo.component';
import { LoadingValidateCodeComponent } from './Shared/Pages/loading-validate-code/loading-validate-code.component';

import { ValidateCorreoComponent } from './Shared/Pages/validate-correo/validate-correo.component';
import { QrCodeModule } from 'ng-qrcode';

@NgModule({
    declarations: [
        AppComponent,
        LoginComponent,
        NotFoundComponent,
        RequestRestorePasswordComponent,
        ChangePasswordComponent,
        RestorePasswordComponent,
        DialogNuevoAspiranteComponent,
        MaintenanceComponent,
        LoadingRestorePasswordComponent,
        LoadingComponent,
        LoadingValidateCorreoComponent,
        LoadingValidateCodeComponent,
        ValidateCorreoComponent,
    ],
    bootstrap: [AppComponent],
    imports: [
        NgChartsModule,
        BrowserModule,
        BrowserAnimationsModule,
        CommonModule,
        FormsModule,
        RouterModule,
        ReactiveFormsModule,
        MaterialDesignModule,
        NgxUiLoaderModule,
        AppRoutingModule,
        RecaptchaModule,
        RecaptchaV3Module,
        QrCodeModule,
    ],
    providers: [
        PeriodoPipe,
        EvaluacionPipe,
        NivelDesempenoPipe,
        GeneroPipe,
        NivelAcademicoPipe,
        {
            provide: RECAPTCHA_V3_SITE_KEY,
            useValue: environment.recaptchaV3.siteKey,
        },
        provideHttpClient(withInterceptorsFromDi()),
    ],
})
export class AppModule {}
